/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'menu': {
    viewBox: '0 0 24 24',
    data: `<path d="M19,6V7.167H5V6Zm0,5.408v1.167H5V11.408Zm0,5.425V18H5V16.833Z" style="fill-rule:evenodd"/>`
  }
})
